'use strict';

import { CurrencyConversion } from '../components/CurrencyConversion.js';
import { Form } from '../helpers/Form.js';
import {DOM} from "../helpers/DOM.js";

export class Donation {
	#form;
	#donationArray = [];
	#baseCurrency;
	#donationRates;
	#hideCurrencySwitcher;
	#donation_tribute_wrapper;
	#donation_tribute;

	constructor() {
		this.#form = document.querySelector(
			'form.levcharity_form.donation_form'
		);


		if ( ! this.#form ) {
			return;
		}

		this.#baseCurrency = this.#form.dataset.basecurrency;
		this.#hideCurrencySwitcher = this.#form.dataset.hideswitcher;
		this.#init();
	}

	async #init() {
		const donationForm = new Form();
		donationForm.setCurrencySymbolForDonationAmount( this.#form );

		donationForm.selectDonationAmount( this.#form, this.#donationArray );

		if ( ! this.#hideCurrencySwitcher ) {
			try {
				const currencyRates = new CurrencyConversion();
				this.#donationRates = await currencyRates.getConversionRates(
					this.#baseCurrency
				);
			} catch ( error ) {
				console.error( error.message );
			}
		}
		document.body.classList.add('loaded');
		donationForm.donationCurrencySwitcher(
			this.#form,
			this.#donationArray,
			this.#donationRates,
		);
		donationForm.watchRecurringInputs( this.#form, this.#donationArray );
		donationForm.watchTributeCheckbox( this.#form );
		donationForm.watchCCFeeCheckbox( this.#form, this.#donationArray );
		donationForm.removeFromSummaryTable( this.#form, this.#donationArray );
		donationForm.preventSubmitByEnter();
		donationForm.cleanValidation( this.#form );
		donationForm.watchValidatedTributeInput(this.#form);

		const submitButton = this.#form.querySelector('.levcharity_form__primary_button.submit');
		donationForm.enableSubmit(submitButton);

		this.clearAllTributeFields()
		this.switchTabsByClicking();
		this.#form.addEventListener( 'submit', ( event ) => {
			event.preventDefault();

			const parentDiv = document.querySelector('.donation-variations-form');
			const validationMessage = parentDiv?.dataset.validationMessage;

			if (parentDiv && parentDiv.classList.contains('require-variation')) {
				let isVariationChecked = false;

				const checkboxes = parentDiv.querySelectorAll('input.donation_variation_checkbox[type="checkbox"]:checked');
				checkboxes.forEach((checkbox) => {
					const index = checkbox.value;
					const customPriceInput = parentDiv.querySelector(`#product_variation_price_${index}`);

					if (!customPriceInput) {
						isVariationChecked = true;
					}
				});

				let customAmountEntered = false;
				const customInputs = parentDiv.querySelectorAll('input[id^="product_variation_price_"]');
				customInputs.forEach((input) => {
					const price = parseFloat(input.value);
					if (!isNaN(price) && price > 0) {
						customAmountEntered = true;
					}
				});

				if (!isVariationChecked) {
					donationForm.printValidation(this.#form, validationMessage);
				}
			}
			this.#donation_tribute_wrapper = document.querySelector('.levcharity_form__field.donation_tribute_wrapper');
			if(this.#donation_tribute_wrapper){
				const computedStyle = window.getComputedStyle(this.#donation_tribute_wrapper);
					if (this.#donation_tribute_wrapper && computedStyle.display !== 'none') {
						const typeSwitcher = this.#donation_tribute_wrapper.getAttribute('data-switcher')
						let inputElements = [];
						let selectElements = [];
						let textAreaElements = [];
						const donationTributeItems = DOM.el('.donation_tribute_items_wrapper');
						const donationRecipentItems = DOM.el('.donation_recipent_items_wrapper');
						const typeSwitcherWrapper = DOM.el('.donation-tribute-switcher');
						if(typeSwitcher === 'true'){
							if(typeSwitcherWrapper){
								if(typeSwitcherWrapper.classList.contains('physically_type')){
									inputElements = DOM.els('div input', donationRecipentItems)
									selectElements = DOM.els('div select', donationRecipentItems)
									textAreaElements = DOM.els('div textarea', donationRecipentItems)
								}else if(typeSwitcherWrapper.classList.contains('electronically_type')){
									inputElements = DOM.els('div input', donationTributeItems)
									selectElements = DOM.els('div select', donationTributeItems)
									textAreaElements = DOM.els('div textarea', donationTributeItems)
								}
							}
						}else{
							inputElements = this.#donation_tribute_wrapper.querySelectorAll('div input');
							selectElements = this.#donation_tribute_wrapper.querySelectorAll('div select');
							textAreaElements = this.#donation_tribute_wrapper.querySelectorAll('div textarea');
						}
						let hasEmptyInput = false;

						inputElements.forEach((input) => {
							if (input.classList.contains('no-validate')) return;
							if (input.value.trim() === '') {
								input.style = 'border: 1px solid red !important';
								hasEmptyInput = true;
							} else {
								input.style = 'border: none';
							}
						});

					textAreaElements.forEach((input) => {
					if (input.classList.contains('no-validate')) return;
					if (input.value.trim() === '') {
						input.style = 'border: 1px solid red !important';
						hasEmptyInput = true;
					} else {
						input.style = 'border: none';
					}
					});



						selectElements.forEach((select) => {
						if (select.classList.contains('no-validate')) return;

						if (select.id === 'donation_tribute_recipient_country' && select.options.selectedIndex === 0) {
							select.style = 'border: 1px solid red !important';
							hasEmptyInput = true;
						} else if (select.id === "donation_tribute_type_0" || select.id === "donation_tribute_type_recipient_0") {
							if(select.value == "Select one" || select.value == "" || select.value == "Select dedication") {
								select.style = 'border: 1px solid red !important';
								hasEmptyInput = true;
							}else{
								select.style = 'border: none';
								select.querySelector('option.initial')?.remove()
							}
						} else {
							select.style = 'border: none';
							if(select?.nextElementSibling?.classList.contains('error-message')) select.nextElementSibling.remove()
						}
					});

					let errorContainer = document.querySelector('.error-container');

					if (hasEmptyInput && !errorContainer) {
						errorContainer = document.createElement('div');
						errorContainer.className = 'error-container';

						const errorMessage = document.createElement('p');
						errorMessage.className = 'error-message';
						errorMessage.textContent = wp.i18n.__('Please fill out all required fields.', 'levcharity');
						errorContainer.appendChild(errorMessage);
						this.#donation_tribute_wrapper.parentNode.insertBefore(errorContainer, this.#donation_tribute_wrapper);
					} else if (!hasEmptyInput && errorContainer) {
						errorContainer.remove();
					}
				}
			}

			if ( this.#donationArray.length === 0 && !this.#form.querySelector('.donation_variations')) {
				donationForm.printValidation( this.#form, wp.i18n.__('You have not selected an amount. Please do so before attempting to move forward', 'levcharity'));
			} else {
				//donationForm.testSubmissionData( this.#form );
				const tributeValidation = donationForm.validateTribute(this.#form);
				const confirmationPopup =  document.querySelector('.levcharity_donation_confirmation_popup');

				if (confirmationPopup) {
					confirmationPopup.style.display = 'flex';
					const selectedOption = confirmationPopup.querySelectorAll('input[name="confirmation_value"]');
					selectedOption.forEach(option => {
						option.checked = false;
						option.addEventListener('click', () => {
							if(option.value === 'yes'){
								donationForm.submitForm(this.#form, 'send_donation_form', this.showErrorMessageInDonateForm, 'donation_form' );
								confirmationPopup.style.display = 'none'
							}else if(option.value === 'no'){
								confirmationPopup.style.display = 'none';
							}
							setTimeout(() => {
								option.checked = false;
							}, 2000)
						});
					});
				}else if(tributeValidation){
					donationForm.submitForm( this.#form, 'send_donation_form', this.showErrorMessageInDonateForm, 'donation_form' );
				}
			}
		} );
	}

	showErrorMessageInDonateForm(responseData) {
		if(responseData.hasOwnProperty('success')) {
			if(responseData.success === false) {
				if(responseData.hasOwnProperty('message')) {
					if (document.body.classList.contains('ajax-loading')) {
						document.body.classList.remove('ajax-loading');
					}

					let errorMessage = document.querySelector('.donation-form-error-message');
					if(!errorMessage){
						errorMessage = document.createElement('p');
						errorMessage.style.color = 'red';
						errorMessage.style.textAlign = 'center';
						errorMessage.classList.add('donation-form-error-message');
					}

					errorMessage.innerText = responseData.message;
					let actionsContainer = document.querySelector('.levcharity_form__actions.levcharity_tabs__actions');
					if(actionsContainer) {
						let actionsContainerParent = actionsContainer.parentElement;
						if(actionsContainerParent){
							actionsContainerParent.prepend(errorMessage);

							const rect = this.#form.getBoundingClientRect();
							const formCenterY =
								rect.top + window.scrollY + rect.height / 2;
							const targetTop =
								formCenterY - window.innerHeight / 2;
							const maxScroll = Math.max(
								0,
								document.documentElement.scrollHeight -
									window.innerHeight
							);
							window.scrollTo( {
								top: Math.max(
									0,
									Math.min( targetTop, maxScroll )
								),
								left: 0,
								behavior: 'smooth',
							} );
						}
					}
				}
			}else{
				
				if(responseData?.redirect_url) {
					window.location.href = responseData.redirect_url;
				} else {
					console.error('Success response but no redirect_url provided');
				}
			}
		}
	}

	switchTabsByClicking() {
		const switchToAmount = document.querySelector('.switch_to_amount');
		const amountNavItem = document.querySelector('.donation_amount_nav_item');
		const amountTab = document.querySelector('.donation_amount_tab');

		const switchToEquipment = document.querySelector('.switch_to_equipment');
		const equipmentNavItem = document.querySelector('.equipment_nav_item');
		const equipmentTab = document.querySelector('.donation_equipment_tab');

		const donationTributeWrapper = document.querySelector('.donation_tribute_wrapper')
		const donationTributeTypeSwitcher = document.querySelector('[name=donation_tribute_type_switcher]')
		const donationTributeItemsWrapper = document.querySelector('.donation_tribute_items_wrapper')
		const donationTributeReceiptItemsWrapper = document.querySelector('.donation_recipent_items_wrapper')

		if(donationTributeTypeSwitcher){
			donationTributeItemsWrapper.style.display = "none"
		}

		switchToAmount?.addEventListener('click', () => {
			equipmentNavItem?.classList.remove('active');
			equipmentTab?.classList.remove('active');
			amountNavItem?.classList.add('active');
			amountTab?.classList.add('active');
		});

		switchToEquipment?.addEventListener('click', () => {
			amountNavItem?.classList.remove('active');
			amountTab?.classList.remove('active');
			equipmentNavItem?.classList.add('active');
			equipmentTab?.classList.add('active');
		})

		donationTributeWrapper?.addEventListener('change', e => {
			if(!donationTributeTypeSwitcher) return;
			if(e.target?.value == 'electronically_type'){
				donationTributeItemsWrapper.style.display = '';
				donationTributeReceiptItemsWrapper.style.display = 'none';
			}
			if(e.target?.value == 'physically_type'){
				donationTributeReceiptItemsWrapper.style.display = '';
				donationTributeItemsWrapper.style.display = 'none';
			}
		})
	}

	 clearAllTributeFields() {
		const donationTributeCheckbox = document.getElementById('donation_tribute');
	    const typeSwitcher = document.querySelector('.donation-tribute-switcher');

		 if (typeSwitcher) {
			 const radioButtons = typeSwitcher.querySelectorAll('input[name="donation_tribute_type_switcher"]');
			 if (radioButtons.length > 0) {
				 if (!radioButtons[0].checked) {
					 radioButtons[0].checked = true;
					 radioButtons[0].click();
				 }
			 }
		 }
	    if(donationTributeCheckbox){
			const shouldKeepChecked = donationTributeCheckbox.defaultChecked;
			donationTributeCheckbox.checked = shouldKeepChecked;
			const donationTributeWrapper = document.querySelector('.donation_tribute_wrapper');
			const inputs = donationTributeWrapper.querySelectorAll('input, textarea, select');
			inputs.forEach(input => {
				if(input.type === 'radio') return;
				if (input.tagName.toLowerCase() === 'select') {
					input.selectedIndex = 0;
				} else {
					input.value = '';
				}
			});

			if (!shouldKeepChecked && donationTributeWrapper) {
				donationTributeWrapper.style.display = 'none';
			}
		}

	}

}
